import { AsYouType } from "libphonenumber-js";
import styles from "./MypageInput.module.scss";
import {
  validateRequired,
  validatePhoneWithHyphen,
} from "../../utils/validate";

const MypagePhoneNumTextField = ({
  type = "text",
  name,
  label,
  subLabel = false,
  setValue,
  register,
  validation = {},
  errors,
  watch,
  required = false,
  placeholder = "",
  autocomplete = null,
  isStatic = false,
  readOnly = false,
}) => {
  const formatValue = (e) => {
    const formattedNumber = new AsYouType("JP").input(e.target.value);
    setValue(name, formattedNumber);
  };

  const returnText = () => {
    const value = watch(name);
    return value && value.length > 0 ? value : <p>&emsp;</p>;
  };

  let txt_validation = { ...validation, ...validatePhoneWithHyphen() };
  if (required) {
    txt_validation = { ...txt_validation, ...validateRequired() };
  }

  return (
    <div className={styles.mypageform__block}>
      <div className={`${styles.mypageform__ttl} ${subLabel ? "fs-4" : ""}`}>
        {label}
        <span className={styles.mypageform__ttl__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </div>
      <div
        className={`${styles.mypageform__field} ${isStatic ? "d-none" : ""}`}
      >
        <input
          type={type ? type : "text"}
          name={name}
          className={`${styles.mypageform__txt} form-control ${
            errors[name] ? "is-invalid" : ""
          }`}
          // maxLength={maxLength}
          placeholder={placeholder}
          autoComplete={autocomplete}
          {...register(name, txt_validation)}
          readOnly={readOnly}
          onBlur={(e) => formatValue(e)}
        />
        <>
          {errors[name] ? (
            <p className={`invalid-feedback ${styles.mypageform__msg}`}>
              {errors[name].message}
            </p>
          ) : (
            <></>
          )}
        </>
      </div>
      {/* 確認画面表示用 */}
      {isStatic && (
        <div className={`${styles.mypageform__label} ws-pre-wrap ps-4`}>
          {returnText()}
        </div>
      )}
    </div>
  );
};

export default MypagePhoneNumTextField;
